import { RegisterEmployabilityCharterRequest } from '@/domain/entities/procedures/RegisterEmployabilityCharterRequest';
import ProceduresRepository from '../../domain/repositories/ProceduresRepository';
import ProceduresDataStore from '../datastores/ProceduresDataStore';
import ProceduresDataStoreFactory from '../factories/ProceduresDataStoreFactory';

export default class ProceduresDataRepository implements ProceduresRepository {
  getModalityOptionList(campus: string, periodId: number) {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.getModalityOptionList(campus, periodId);
  }

  getProceduresByStudent() {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.getProceduresByStudent();
  }

  getProcedureInformation(procedureId: number, studentType = '') {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.getProcedureInformation(
      procedureId,
      studentType
    );
  }

  // getStudentProcedureStatus() {
  //   const proceduresDataStore: ProceduresDataStore =
  //     ProceduresDataStoreFactory.create();
  //   return proceduresDataStore.getStudentProcedureStatus();
  // }
  getProcedureRequestDetail(procedureId: number, requestId: number) {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.getProcedureRequestDetail(
      procedureId,
      requestId
    );
  }

  getStudentInformation() {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.getStudentInformation();
  }

  getProceduresCategory() {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.getProceduresCategory();
  }

  getCampusByModality(modalityId: string) {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.getCampusByModality(modalityId);
  }

  getProgramByCampus(campusId: string, modalityId: string) {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.getProgramByCampus(campusId, modalityId);
  }

  getProceduresNotAutomated() {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.getProceduresNotAutomated();
  }

  registerTicketNotAutomated(request: any) {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.registerTicketNotAutomated(request);
  }

  registerCarnet(request: any) {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.registerCarnet(request);
  }

  activateRegisterCarnet(
    requestId: number,
    procedureId: number,
    deliveryMode: string,
    career: string
  ) {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.activateRegisterCarnet(
      requestId,
      procedureId,
      deliveryMode,
      career
    );
  }

  cancelRegisterCarnet(requestId: number, procedureId: number) {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.cancelRegisterCarnet(requestId, procedureId);
  }

  getProceduresCreated(request: any) {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.getProceduresCreated(request);
  }

  getYearsOfProcedures() {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.getYearsOfProcedures();
  }

  registerChangePhoto(imgBase64: string, type: string, period: string) {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.registerChangePhoto(imgBase64, type, period);
  }

  registerEmployabilityCharter(request: RegisterEmployabilityCharterRequest) {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.registerEmployabilityCharter(request);
  }

  getPeriodsWithDebts(currentPeriod: string) {
    const proceduresDataStore: ProceduresDataStore =
      ProceduresDataStoreFactory.create();
    return proceduresDataStore.getPeriodsWithDebts(currentPeriod);
  }
}
